import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { signin, signout, tenantCheck } from "./loginAPI";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";
// import { enable_pr_app } from "../../../utilities/helper";

const initialState = {
  loading: false,
  // token: "",
  user: null,
  first_name: "",
  last_name: "",
  company_name: "",
  contact_person_email: "",
  // PAN_number: "",
  legal_name: "",
  is_domestic: "",
  roles: [],
  vendor_id: "",
  features: [],
  tenantData: {},
  client: {},
};

const actions = {
  LOGIN: "login/LOGIN",
  TENANT: "tenant/TENANT",
};

export const login = createAsyncThunk(actions.LOGIN, async (payload) => {
  const response = await signin(payload);

  if (response?.success) {
    const {
      user_id,
      first_name,
      last_name,
      company_name,
      contact_person_email,
      // PAN_number,
      legal_name,
      is_domestic,
      roles,
      vendor_id,
      features,
    } = response;
    // NOTE: token is intentionally excluded — auth is handled via httpOnly cookie.
    // Storing the raw JWT in localStorage is XSS-vulnerable (FE-SEC-01).
    let newUser = {
      user_id,
      first_name,
      last_name,
      company_name,
      contact_person_email,
      // PAN_number,
      legal_name,
      is_domestic,
      roles,
      vendor_id,
      features,
    };

    LocalStorage.setItem(SESSION_KEY, JSON.stringify(newUser));
    LocalStorage.setItem("setupTime", new Date().getTime());
    // eslint-disable-next-line array-callback-return
    //Todo fix permissions
  }
  return response;
});

export const tenant = createAsyncThunk(actions.TENANT, async (payload) => {
  const response = await tenantCheck(payload);
  return response;
});

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    resetLoginDetails: (state) => {
      // state.token = "";
      state.user_id = null;
      state.first_name = "";
      state.last_name = "";
      state.company_name = "";
      state.contact_person_email = "";
      // state.PAN_number = "";
      state.legal_name = "";
      state.is_domestic = "";
      state.roles = [];
      state.vendor_id = "";
    },
    TenantDetails: (state, action) => {
      state.client = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const {
          message: msg,
          first_name,
          user_id,
          last_name,
          company_name,
          contact_person_email,
          // PAN_number,
          legal_name,
          is_domestic,
          roles,
          vendor_id,
        } = action.payload;
        // token is not extracted — auth is via httpOnly cookie (FE-SEC-01)

        state.loading = false;
        state.user_id = user_id;
        state.first_name = first_name;
        state.last_name = last_name;
        state.company_name = company_name;
        state.contact_person_email = contact_person_email;
        // state.PAN_number = PAN_number;
        state.legal_name = legal_name;
        state.is_domestic = is_domestic;
        state.roles = roles;
        state.vendor_id = vendor_id;
        state.features = action.payload?.features || [];
        if (action.payload?.success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(login.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(tenant.pending, (state) => {
        state.loading = true;
      })
      .addCase(tenant.fulfilled, (state, action) => {
        const { success, data } = action.payload;

        if (success) {
          LocalStorage.setItem("client", data);
          state.client = data;
          state.loading = false;
        } else {
          message.error(data);
        }
      })
      .addCase(tenant.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  },
});
export const loginActions = loginSlice.actions;
export const { resetLoginDetails, TenantDetails } = loginSlice.actions;

export const logout = (navigate) => async (dispatch) => {
  try {
    await signout();
  } catch (error) {
    console.error("Signout error:", error);
  }
  localStorage.clear();
  dispatch(resetLoginDetails());
  message.success("Thank you! You have logged out of your account");
  if (navigate) {
    navigate("/login");
  } else {
    window.location.href = "/login";
  }
};

export const clientClear = () => (dispatch) => {
  localStorage.clear();
  dispatch(TenantDetails());
};

export default loginSlice.reducer;
